module.exports = __webpack_public_path__ + "static/img/rank_background_official.afc4b04c.png";